import { APP_BACKGROUND } from '@unistocks/shared/consts';
import { useIsDarkMode } from '@unistocks/shared/hooks/use-active-color-scheme';
import { Image, ImageStyle } from 'expo-image';
import { PropsWithChildren } from 'react';
import { Platform, StyleSheet } from 'react-native';
import { isWeb, useTheme } from 'tamagui';

export const Background: React.FC<PropsWithChildren> = ({ children }) => {
  const theme = useTheme();
  const isDarkMode = useIsDarkMode();

  const backgroundColor = isWeb
    ? theme.gray1.get()
    : isDarkMode
      ? theme.gray2.get()
      : theme.gray1.get();

  return (
    <>
      <Image source={APP_BACKGROUND} style={[style, { backgroundColor }]} />
      {children}
    </>
  );
};

const style = StyleSheet.compose(
  StyleSheet.absoluteFill,
  Platform.select({
    web: {
      // Works for web but not valid ImageStyle
      position: 'fixed'
    }
  })
) as unknown as ImageStyle;

Background.displayName = 'Background';
